import React from 'react'

export default function Container6() {
  return (
    <div className='container my-4 py-5'>
    <h3 className='fw-bold'>Immernoch ein Dauerbrenner</h3>
    <h1 className='fw-bold'> <span className='text-success1'>Einnahmen</span> aus Außenwerbung</h1>
    <div className='row'>
    <div className='col-lg-12 col-md-12 col-sm-12 text-center '>
        <img src="./s3.png" className='img-fluid text-center w-50' alt='not found'/>
    </div>
</div>
</div>
  )
}
